export const getMaxShownFlights = () => {
  let maxShown = 15

  if (typeof window !== 'undefined') {
    if (window.innerWidth > 1600) {
      maxShown = Math.floor(window.innerHeight / 163)
    }

    if (window.innerWidth > 992) {
      maxShown = Math.floor(window.innerHeight / 136)
    }
  }
  if (maxShown < 15) {
    return 15
  }
  return maxShown
}